import angular from "angular";
import toastr from "angular-toastr";
import LocaleService from "app/services/LocaleService";
import dcModal from "modules/dc-ui/dc-modal";
import DownloadRA from "app/services/DownloadRA";
import ServiceRA from "app/services/ServiceRA";
import AuthenticationService from "./AuthenticationService";
import Utils from "./Utils";

export default angular.module("services.DownloadService",
  [toastr, LocaleService, dcModal, DownloadRA, ServiceRA, AuthenticationService, Utils]).factory("DownloadService",
  ["$http", "toastr", "$log", "$window", "$q", "LocaleService", "DialogService", "DownloadRA", "AuthenticationService",
    "ServiceRA", "Utils", "$timeout", "FeatureService", "ConfigService",
    function DownloadService($http, toastr, $log, $window, $q, LocaleService, DialogService, DownloadRA, AuthenticationService, ServiceRA, Utils, $timeout, FeatureService, ConfigService) {

      var url = "";
      var filename = "Statement.csv";

      function createDownloadUrl(url) {
        var defer = $q.defer();

        //TODO: talk to download service
        defer.resolve(url);

        return defer.promise;
      }

      function downloadUrl(url) {

        var defer = $q.defer();

        $http.get(url).success(function (data, status, headers) {
          var contentType = headers["content-type"] || "text/csv";

          defer.resolve(data, contentType, status, headers);

        }).error(function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function saveDownload(data, filename, contentType, status, headers) {

        var defer = $q.defer();

        var charset = "charset=utf-8";

        var hiddenElement = document.createElement('a');

        hiddenElement.href = 'data:attachment/pdf;charset=utf-8;base64,' + encodeURI(data);
        hiddenElement.target = '_self';
        hiddenElement.download = filename;
        hiddenElement.click();

        /* var element = angular.element('<a/>');
         element.attr({
             href: 'data:attachment/pdf;charset=utf-8,' + encodeURI(data),
             target: '_self',
             download:'statement.pdf'
         })[0].click();
         */
        //document.location.href = "data:application/pdf;base64," + encodeURIComponent(data);
        defer.resolve(data, contentType, status, headers);

        return defer.promise;

      }

      function getDocumentType(type) {
        var documentType = "X";

        if (type === "pdf") {
          documentType = "F";
        }
        else if (type === "csv") {
          documentType = "X";
        }

        return documentType;
      }

      function downloadInvoice(id, type, filename) {

        var documentType = getDocumentType(type);

        AuthenticationService.getUser().then(function (user) {
          exportFile({
            type: "archive",
            exportType: type
          }, {
              "cinvIds": [id],
              "baaCinvIds": [id],
              "documentType": documentType
            }, {
              "_id": user._id
            }, encodeURI(filename), "downloadInvoice");
        });
      }

      function getDownloadDateTime() {
        return moment(new Date()).format("YYYYMMDD_HHmmss");
      }

      function downloadInvoices(ids, type, filename) {
        var documentType = getDocumentType(type);

        AuthenticationService.getUser().then(function (user) {
          exportFile({
            type: "archive"
          }, {
              "cinvIds": ids,
              "baaCinvIds": ids,
              "documentType": documentType
            }, {
              "_id": user._id
            }, filename, "downloadInvoice");
        });
      }

      function getDownloadErrorUrl(url) {
        if (url) {
          if (url.indexOf("downloadError") >= 0) {
            return url;
          } else {
            if (url.indexOf("?") >= 0) {
              return url + "&downloadError=true";
            } else {
              return url + "?downloadError=true";
            }
          }
        } else {
          return "";
        }
      }

      function exportFile(metadata, params, referrer, filename, action) {

        if (params) {
          params.failureUrl = getDownloadErrorUrl($window.location.href);
        }

        var body = {
          "metadata": {
            "sourceType": metadata.type,
            "outputDataType": metadata.exportType || "csv",
            "n": 2,
            "expiresAt": moment(new Date()).add(60, "seconds").format("YYYY-MM-DD HH:mm Z")
          },
          "params": params || undefined,
          "referrer": referrer,
          "host": ConfigService.get("urls.dcb-downloads", true)
        };

        var headers = Utils.prepareHeaders(action);
        FeatureService.hasDemoUserFeature().then(function (hasFeature) {
          if ((hasFeature) && (action === "downloadInvoice")) {
            var dataType;
            var invIds = _.union(params.baaCinvIds, params.cinvIds);
            if (params.documentType === "F") {
              dataType = "pdf";
            } else {
              dataType = "csv";
            }

            $window.location = "/invoices?" + Utils.getQueryString({
              name: filename,
              type: dataType,
              id: invIds
            });

            /*$http.get("/invoices?id=1").then((res)=> {
             $window.STATE = res.data;
             }, (err)=> {
             console.error("ERROR: ", err);
             });*/

            //$window.location = data.url + "?filename=" + filename;
          }
          else {
            if (hasFeature) {
              var dataUrl = ConfigService.get("demo.urls." + action, true); // zB demo.urls.downloadTransactions
              if (dataUrl) {
                data.url = dataUrl;
              }
            }
            return DownloadRA.all("links").post(body, {
              d: false,
              base64: false
            }, headers).then(function ok(data) {
              //console.log("params: ", params);
              if (data.url) {
                $window.location = data.url + "?filename=" + filename;
              } else {
                $window.location = getDownloadErrorUrl($window.location.href);
                $log.error("No download url received: " + JSON.stringify(data));
              }
            }, function (err) {
              Utils.handleError(err);
            });
          }
        });
      }

      function exportQuery(url, exportType, fields, filename, action) {

        var encodedURI = encodeURIComponent(url);
        AuthenticationService.getUser().then(function (user) {
          exportFile({
            type: "service",
            exportType: exportType
          }, {
              locale: LocaleService.getCurrentLocale(),
              "url": encodedURI,
              fieldsList: fields
            }, {
              "_id": user._id
            }, filename, action);
        });
      }

      function handleDownloadError(params) {
        processDownloadError(params.downloadError);
      }

      function processDownloadError(error) {
        if (error) {
          toastr.error(LocaleService.get("errors.downloadError"));
        }
      }

      return {
        getDownloadDateTime: getDownloadDateTime,
        createDownloadUrl: createDownloadUrl,
        downloadUrl: downloadUrl,
        downloadInvoice: downloadInvoice,
        downloadInvoices: downloadInvoices,
        exportQuery: exportQuery,
        handleDownloadError: handleDownloadError
      };

    }]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/DownloadService.js